import { letterToKeyCode } from "@hubrise/react-components"
import * as React from "react"

import { useKeyboardContext } from "shared/components/KeyboardContext"

const useAltShortcut = (label: string, shortcutLetter: string | undefined, action: () => void): React.ReactNode => {
  const { altKeyPressed } = useKeyboardContext()

  React.useEffect(() => {
    if (shortcutLetter !== undefined) {
      const keyCode = letterToKeyCode(shortcutLetter)

      const handleKeyDown = (event: KeyboardEvent): void => {
        if (event.altKey && event.code === keyCode) action()
      }

      document.body.addEventListener("keydown", handleKeyDown)
      return () => document.removeEventListener("keydown", handleKeyDown)
    }
  }, [shortcutLetter, action])

  if (shortcutLetter !== undefined && altKeyPressed) {
    const regexp = new RegExp(`(.*)(${shortcutLetter})(.*)`, "i")
    const match = regexp.exec(label)
    if (!match) throw `Letter ${shortcutLetter} not found in '${label}'`
    return (
      <>
        {match[1]}
        <u>{match[2]}</u>
        {match[3]}
      </>
    )
  } else return label
}

export default useAltShortcut
